<template>
  <div class="mb-3">
    <v-layout wrap>
      <v-flex xs12>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" @click.native="$emit('close')">Edit Items</v-btn>
          </div>
        </v-card-actions>
        <v-data-table
          :headers="groupTableHeaders"
          :items="groupSummaryId"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr @click="props.item.expanded = !props.item.expanded">
              <td>
                <v-icon v-if="!props.item.expanded" color="primary">keyboard_arrow_down</v-icon>
                <v-icon v-else color="primary">keyboard_arrow_up</v-icon>
              </td>
              <td>{{ props.item.includedItems.length }}</td>
              <td>{{ props.item.userGroupTypeValue }}</td>
              <td style="width: 100%"><GroupTrackClient :type="props.item.userGroupTypeCode" :value2="props.item.userGroupTypeValue2" /></td>
            </tr>
            <tr v-if="props.item.expanded">
              <td colspan="4">
                <v-data-table
                  :headers="groupIncTableHeaders"
                  :items="props.item.includedItems"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                  item-key="groupId"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" @click.native="$emit('close')">Edit Items</v-btn>
          </div>
        </v-card-actions>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import GroupTrackClient from './GroupTrackClient'
export default {
  name: 'manage-user-groups-view-summary',
  components: {
    GroupTrackClient
  },
  props: {
    groupSummary: Array
  },
  data() {
    return {
      groupTableHeaders: [
        {
          text: '',
          value: false,
          sortable: false
        },
        {
          text: 'Num',
          value: 'num'
        },
        {
          text: 'Name',
          value: 'userGroupTypeValue'
        },
        {
          text: 'Type',
          value: 'type'
        }
      ],
      groupIncTableHeaders: [
        {
          text: 'Group Id',
          value: 'groupId'
        },
        {
          text: 'Group Name',
          value: 'groupName'
        },
        {
          text: 'External Group Id',
          value: 'externalGroupId'
        },
        {
          text: 'Alt Group Id',
          value: 'altGroupId'
        },
        {
          text: 'Client Id',
          value: 'clientId'
        },
        {
          text: 'Client Name',
          value: 'clientName'
        }
      ]
    }
  },
  computed: {
    groupSummaryId() {
      return this.groupSummary.map(v => ({
        num: v.includedItems.length,
        type: v.userGroupTypeCode + v.userGroupTypeValue2,
        ...v
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
 tr {
   background: $black-5 !important;
 }
</style>
